<template>
  <div class="course-tooltip-container">
    <div class="item-wrap">
      <div v-if="item.classroomName" class="course-name" style="height: 28px">
        {{ item.classroomName }}
      </div>
      <div class="teacher-name" style="height: 28px">
        任课教师：{{ item.teacherName ? item.teacherName : '未分配' }}
      </div>
      <!-- <div class="teacher-name" style="height: 28px">
        驻校教务：{{ item.teacherName ? item.teacherName : '未分配' }}
      </div> -->
      <div v-if="item.time" class="course-time" style="height: 28px">
        上课时间：{{ item.time }}
      </div>
      <div style="height: 28px">
        年级：{{
          `${getGradeName(item.gradeMin)} ~ ${getGradeName(item.gradeMax)}`
        }}
      </div>
      <div v-if="item.conflictList" class="teacher-conflict-list-box">
        <div v-for="teaItem in item.conflictList" :key="teaItem.teacherId">
          <div>该课程教师{{ teaItem.teacherName }}在本时段内已有排课！</div>
          <div
            v-for="(vosItem, index) in teaItem.vos"
            :key="index"
            class="vos-box"
          >
            <div>学校名称：{{ vosItem.schoolName }}</div>
            <div>课程名称：{{ vosItem.classroomName }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 教育局端仅可查看 -->
    <!-- <div v-if="type === 1 && portOrg != 1" class="btn">
      <Button type="info" size="small" @click="handleUpdate">修改</Button>
      <Button type="error" size="small" @click="handleUpdateStatus"
        >删除</Button
      >
    </div> -->
    <Modal
      v-model="modal"
      title="修改课程信息"
      ok-text="保存"
      width="670"
      @on-ok="handleOk"
    >
      <div class="flex-box">
        <div style="margin-right: 20px">课程名称:</div>
        {{ item.classroomName }}
      </div>
      <div class="flex-box">
        <div class="name">任教老师:</div>
        <Select
          v-model="setData.teacherIds"
          multiple
          filterable
          :remote-method="remoteMethod"
          :loading="loading"
          style="width: 400px; margin: 0 20px"
        >
          <Option
            v-for="option in teacherList"
            :key="option.teacherIds"
            :value="option.teacherIds"
          >{{ option.userName }}</Option>
        </Select>
      </div>
      <div class="flex-box">
        <div class="name">驻校教务:</div>
        <Select
          v-model="setData.teacherSchIds"
          multiple
          filterable
          :remote-method="remoteMethod"
          :loading="loading"
          style="width: 400px; margin: 0 20px"
        >
          <Option
            v-for="option in teacherList"
            :key="option.teacherIds"
            :value="option.teacherIds"
          >{{ option.userName }}</Option>
        </Select>
      </div>
      <div class="flex-box">
        上课时间:
        <Select v-model="setData.week" style="width: 80px; margin: 0 20px">
          <Option
            v-for="item in weekList"
            :key="item.value"
            :value="item.value"
          >{{ item.label }}</Option>
        </Select>
        {{ item.time }}
      </div>
    </Modal>
    <ConflictModal
      v-model="conflictModal"
      :list="conflictModalData"
    ></ConflictModal>
  </div>
</template>
<script>
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import ConflictModal from './ConflictModal.vue';
import common from '@/request/common/index.js';
import { gradeList } from '@utils/dictionary';
import { mapState } from 'vuex';
export default {
  components: { ConflictModal },
  props: {
    item: {
      type: Object,
      default: () => { }
    },
    schoolId: {
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      conflictModal: false,
      conflictModalData: [],
      modal: false,
      loading: false,
      weekList: [{
        value: 1,
        label: '周一'
      }, {
        value: 2,
        label: '周二'
      }, {
        value: 3,
        label: '周三'
      }, {
        value: 4,
        label: '周四'
      }, {
        value: 5,
        label: '周五'
      }, {
        value: 6,
        label: '周六'
      }, {
        value: 7,
        label: '周日'
      }],
      teacherList: [],
      setData: {
        timeId: 0, // 时间段id
        teacherIds: [], // 教师列表,
        teacherSchIds: [], // 驻校教务
        week: 0 // 周
      },
      queryTeacher: {
        pageNum: 1,
        pageSize: 20,
        userName: ''
      }
    };
  },
  computed: {
    ...mapState(['portOrg'])
  },
  methods: {
    getGradeName(grade) {
      let result = '';
      gradeList.filter(item => {
        if (item.value === grade) {
          result = item.label;
        }
      });
      return result;
    },
    handleUpdate() {
      this.modal = true;
    },
    async handleOk() {
      if (this.setData.teacherIds === 0) {
        this.$Message.warning('请选择任教老师');
        return;
      }
      if (!this.setData.week) {
        this.$Message.warning('请选择上课时间');
        return;
      }
      this.setData.timeId = this.item.timeId;
      const res = await courseSchedulCenter.postCourseScheduleUpdateApi(this.setData);
      if (res.status === 200 && res.message.length) {
        this.conflictModalData = res.message;
        this.conflictModal = true;
      } else if (res.status === 200) {
        this.$emit('refresh');
      }
    },
    async getTeacherList() {
      this.queryTeacher.schoolId = this.schoolId;
      const res = await common.getTeacherListNew(this.queryTeacher);
      this.loading = false;
      console.log(res);
      this.teacherList = res.message.list.map(item => ({
        teacherIds: item.userId,
        userName: item.userName
      }));
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        this.queryTeacher.userName = query;
        this.getTeacherList();
      } else {
        this.teacherList = [];
      }
    },
    async handleUpdateStatus() {
      const res = await courseSchedulCenter.postCourseScheduleUpdateStatusApi({
        week: this.item.weekDate,
        timeId: this.item.timeId,
        teacherIds: this.item.teacherIdList,
        classroomId: this.item.classroomId,
        status: 2 // 1 开展 2 未开展
      });
      if (res.status === 200 && res.message && res.message.length) {
        this.conflictModalData = res.message;
        this.conflictModal = true;
      } else if (res.status === 200) {
        this.$emit('refresh');
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.course-name {
  min-width: 160px;
}
.teacher-conflict-list-box {
  margin-top: 30px;
  // max-height: 300px;
  // overflow-y: scroll;
}
/deep/.ivu-modal-body {
  padding: 40px;
}
.flex-box {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.course-tooltip-container {
  /* padding: 10px; */
  .btn {
    display: flex;
    justify-content: space-around;
  }
  .item-wrap {
    margin-bottom: 30px;
  }
}
</style>
